import Vue from 'vue'
import VueRouter from 'vue-router'
import Statistics from '../views/Statistics.vue'
import Projects from '../views/Projects.vue'
import Packages from '../views/Packages.vue'
import BidRecords from '../views/BidRecords.vue'
import Import from '../views/Import.vue'
import BidderAnalysis from '../views/BidderAnalysis.vue'
import Help from '../views/Help.vue'
import Login from '../views/Login.vue'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    redirect: '/statistics'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: Statistics
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects
  },
  {
    path: '/packages',
    name: 'Packages',
    component: Packages
  },
  {
    path: '/bid-records',
    name: 'BidRecords',
    component: BidRecords
  },

  {
    path: '/bidder-analysis',
    name: 'BidderAnalysis',
    component: BidderAnalysis
  },
  {
    path: '/import',
    name: 'Import',
    component: Import
  },
  {
    path: '/help',
    name: 'Help',
    component: Help
  }
]


const router = new VueRouter({

  routes
})


// 简单前端路由守卫：未登录跳转登录页
router.beforeEach((to, from, next) => {
  if (to.path === '/login') return next()
  const token = localStorage.getItem('auth_token')
  if (!token) return next({ path: '/login', query: { redirect: to.fullPath } })
  next()
})

export default router
